const value = {
    name: 'Name',
    recommendedUnits: 'Recommended units for the role',
    editingProjectFields: 'Editing project fields',
    editingProjectTeams: 'Editing project teams',
    creatingNewProfiles: 'Creating new profiles',
    editingProfiles: 'Editing profiles',
    generatingReports: 'Generating reports',
    creatingRequirements: 'Creating requirements',
    acceptingAndDeletingRequirements: 'Accepting and deleting requirements',
    receivingNotificationsOfNewComments: 'Receiving notifications of new comments',
    viewingUnverifiedRequirements: 'Viewing unverified requirements',
    viewingRequirementsOfExternalRegulatoryAuthorities: 'Viewing requirements of external regulatory authorities',
    integratingASWithJira: 'Integrating AS with Jira',
    managingRequirementsVerification: 'Managing requirements verification',
    terminatingAcceptanceTests: 'Terminating acceptance tests',
    rolesUpdatedTitle: 'Roles have been updated',
    rolesUpdatedMessage: 'The roles have been updated. Units will appear later.',
    writeRequirementRemarks: 'Make notes on requirements',
  };

export default value;
